import { NAMESPACE, SUPPORTED_LANG } from 'app/constants/common'
import commonEn from '@root/locales/en/common.json'
import commonHi from '@root/locales/hi/common.json'
import commonBn from '@root/locales/bn/common.json'
import commonMr from '@root/locales/mr/common.json'
import commonGu from '@root/locales/gu/common.json'

const resources = {
  [SUPPORTED_LANG.en]: {
    [NAMESPACE.common]: commonEn,
  },
  [SUPPORTED_LANG.hi]: {
    [NAMESPACE.common]: commonHi,
  },
  [SUPPORTED_LANG.bn]: {
    [NAMESPACE.common]: commonBn,
  },
  [SUPPORTED_LANG.gu]: {
    [NAMESPACE.common]: commonGu,
  },
  [SUPPORTED_LANG.mr]: {
    [NAMESPACE.common]: commonMr,
  },
}

export default resources
